/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

// const fontSize = {
// 	xsm5: 9,
// 	xsm4: 12,
// 	xsm3: 14,
// 	xsm2: 16,
// 	xsm: 20,
// 	sm: 22,
// 	md: 26,
// 	lg: 30,
// 	xlg: 32,
// 	xlg2: 40,
// 	xlg3: 46,
// 	xlg4: 50,
// 	xlg5: 60
// };

const pxTorem = (pxval: number, basePx = 16): string => {
	return `${pxval / basePx}rem`;
};

export const fontSize = {
	f10: pxTorem(10),
	f12: pxTorem(12),
	f16: pxTorem(16),
	f18: pxTorem(18),
	f20: pxTorem(20),
	f24: pxTorem(24),
	f32: pxTorem(32)
};

export default fontSize;
